import { Component, inject } from '@angular/core'

import { AnalystNotesComponent } from '../../../../../../../modules/shared/components/analyst-notes/analyst-notes.component'
import { PackageViewService } from '../../../../../services/reader/package-view.service'

@Component({
  standalone: true,
  selector: 'default-research-tab',
  imports: [AnalystNotesComponent],
  templateUrl: './research-tab.component.html',
  styleUrls: ['./research-tab.component.scss'],
})
export class ResearchTabComponent {
  private readonly pkgView = inject(PackageViewService)

  readonly pkg = this.pkgView.activePackage
}
